import backend, {LOOM_API} from 'utils/backend/loom/api_library';

import {
  adaptLoomCommunications,
  adaptLoomIntakeSubmissions,
  adaptLoomWorkflows,
} from './workflow_adapter';

const loomApi = () => {
  if (!LOOM_API) {
    throw new Error('REACT_APP_LOOM_API must be configured before Loom workflow reads can be enabled.');
  }

  return LOOM_API.replace(/\/$/, '');
};

// These reads take Loom's client id, never a legacy RN: Loom links a workflow to its clients by id.
const clientPath = (clientId) => `${loomApi()}/api/careos/clients/${encodeURIComponent(clientId)}`;

const listForClient = async (clientId) => {
  const response = await backend.get(`${clientPath(clientId)}/workflows`);
  return adaptLoomWorkflows(response);
};

const listIntakeSubmissionsForClient = async (clientId) => {
  const response = await backend.get(`${clientPath(clientId)}/intake-submissions`);
  return adaptLoomIntakeSubmissions(response);
};

const listCommunicationsForClient = async (clientId) => {
  const response = await backend.get(`${clientPath(clientId)}/communications`);
  return adaptLoomCommunications(response);
};

const completeForClient = (clientId, workflowId) => {
  return backend.post(`${clientPath(clientId)}/workflows/${encodeURIComponent(workflowId)}/complete`);
};

export default {
  listForClient,
  listIntakeSubmissionsForClient,
  listCommunicationsForClient,
  completeForClient,
};
